module.exports = __webpack_public_path__ + "img/place_default.453cff11.png";